import { createSelector } from '@ngrx/store';
import * as fromFeature from '../../reducers.index';
import { BoelsAlternatesState } from '../reducers/boels-alternates.reducers';

export const getAlternatesState = createSelector(
  fromFeature.getStoreState,
  (state: fromFeature.BoelsState) => state.alternatesState,
);

export const getAlternatesList = createSelector(
  getAlternatesState,
  (state: BoelsAlternatesState) => state.alternates,
);

export const isAlternatesDataLoading = createSelector(
  getAlternatesState,
  (state) => state.loading,
);

export const isAlternatesDataSuccess = createSelector(
  getAlternatesState,
  (state) => state.success,
);
